import React from 'react';
import { IconArrowDownRegular } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

import { GetFittingModelList_pdp_base_info_fitting_model_list_item_list as Model } from '../../../../../model-size/graphql/fitting-model-list_types.2';
import { ModelList } from './ModelList';

interface ModelLayoutProps {
  modelList: Model[];
  displayCount: number | null;
  displayButton: boolean;
  onClickMore: () => void;
}
export const ModelLayout: React.FC<React.PropsWithChildren<ModelLayoutProps>> = ({
  modelList,
  displayCount,
  displayButton,
  onClickMore,
}) => {
  return (
    <Wrapper>
      <Title className={Typography.BODY_18_SEMIBOLD}>모델 정보</Title>
      <ModelList modelList={modelList} displayCount={displayCount} />
      {displayButton && (
        <Button onClick={onClickMore}>
          <span className={Typography.BODY_15_SEMIBOLD}>더 보기</span>
          <IconArrowDownRegular width={20} height={20} v3Color='gray950' />
        </Button>
      )}
    </Wrapper>
  );
};

const Button = styled.button`
  margin: 8px 16px 4px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 32px);
  height: 44px;
  border-radius: 100px;
  border: 1px solid ${vars.v3Color.gray200};

  span {
    margin-right: 3px;
  }
`;

const Wrapper = styled.div`
  padding: 0 0 16px 0;
  border-top: 8px solid ${vars.v3Color.gray100};
`;

const Title = styled.div`
  padding: 20px 16px 8px;
  color: ${vars.v3Color.gray900};
`;
